import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import PartsOrderApp from './components/PartsOrder/PartsOrderApp';

// Import all styles - these will be bundled with the widget
import './styles/app.scss';
import './styles/widget.scss';
import './components/Agent/AgentChat.scss';
import './components/PartsOrder/PartsOrder.scss';

// Custom Element Definition
class OperviaPartsOrderElement extends HTMLElement {
  private root: Root | null = null;
  private mountPoint: HTMLDivElement | null = null;

  static get observedAttributes() {
    return ['org-id'];
  }

  connectedCallback() {
    const orgId = this.getAttribute('org-id');

    if (!orgId) {
      console.error('Opervia Parts Order Widget: org-id attribute is required');
      this.innerHTML = '<div style="padding: 20px; color: red;">Error: org-id attribute is required</div>';
      return;
    }

    // Create mount point
    this.mountPoint = document.createElement('div');
    this.mountPoint.className = 'opervia-parts-order-widget-root';
    this.appendChild(this.mountPoint);

    // Mount React app
    this.root = createRoot(this.mountPoint);
    this.root.render(
      <React.StrictMode>
        <PartsOrderApp organizationId={orgId} embedded />
      </React.StrictMode>
    );

    // Notify parent that widget is loaded
    window.dispatchEvent(new CustomEvent('opervia-parts-order-loaded'));
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'org-id' && oldValue !== newValue && this.root && this.mountPoint) {
      this.root.render(
        <React.StrictMode>
          <PartsOrderApp organizationId={newValue} embedded />
        </React.StrictMode>
      );
    }
  }
}

// Register the custom element
if (!customElements.get('opervia-parts-order')) {
  customElements.define('opervia-parts-order', OperviaPartsOrderElement);
}

// Export for module usage
export { OperviaPartsOrderElement };

// Auto-initialize log
if (typeof window !== 'undefined') {
  console.log('Opervia Parts Order Widget loaded successfully');
}
